<template>
  <div class="centered-container">
    <md-content class="md-elevation-3">
      <div class="title">
        <img src="@/assets/logo.svg" alt=""/>
        <div class="md-title" v-translate>auth.title</div>
        <div class="md-body-1"></div>
      </div>
      <div class="form">
        <md-field :class="getValidationClass('username')">
          <label v-translate>auth.email</label>
          <md-input v-model="username" autofocus></md-input>
          <span v-translate class="md-error" v-if="!$v.username.required">auth.error.required.login</span>
        </md-field>
        <md-field md-has-password :class="getValidationClass('password')">
          <label v-translate>auth.password</label>
          <md-input v-model="password" type="password"></md-input>
          <span v-translate class="md-error" v-if="!$v.password.required"
          >auth.error.required.password</span
          >
        </md-field>
        <span v-translate class="mk-error" v-if="errorLogin"
        >auth.error.fail</span
        >
      </div>

      <div class="actions md-layout md-alignment-center-space-between">
        <md-button class="md-raised md-primary" @click="validateUser"
        ><span v-translate>auth.button.login</span>
        </md-button>
      </div>
      <div class="loading-overlay" v-if="loading">
        <md-progress-spinner
          md-mode="indeterminate"
          :md-stroke="2"
        ></md-progress-spinner>
      </div>
    </md-content>
  </div>
</template>
<script>
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

import {AUTH_REQUEST} from '@/store/actions/auth'

export default {
  name: 'login',
  mixins: [validationMixin],
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      errorLogin: false
    }
  },
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    login: function () {
      this.loading = true
      const {username, password} = this
      let $this = this
      this.$store
        .dispatch(AUTH_REQUEST, {username, password})
        .then((n) => {
          console.log(n)
          this.$router.go(n)
        })
        .catch(function () {
          $this.loading = false
          $this.errorLogin = true
        })
    },
    validateUser () {
      this.errorLogin = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.login()
      }
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue